// extracted by mini-css-extract-plugin
module.exports = {"screen":"ReportEditor_screen__1-V1w","row":"ReportEditor_row__QdYvw","ag-cell":"ReportEditor_ag-cell__ICD_S","errorMsg":"ReportEditor_errorMsg__3NZQM"};